export default __webpack_public_path__ + "static/media/fw-lily-er-Yellow Gold.743a5d27.mp4";